module.exports = __webpack_public_path__ + "static/media/Fiji.76517cb4.png";